<template>
  <div
    :class="{ 'ripple--expand': expand }"
    class="ripple"
  />
</template>

<script>
export default {
  name: 'Ripple',

  props: {
    expand: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" src="@/assets/components/ripple/ripple-view.scss"></style>



// WEBPACK FOOTER //
// ripple-view.vue